import { useModalButtonActions } from "@/hooks/useModalButtonActions";
import { FC } from "react";
import Icon from "../Icon";
import ThemeWrapper from "../ThemeWrapper";
import { AiFeatureSetProps } from "./AiFeatureSet";


export const AiFeatureCard: FC<AiFeatureSetProps['aiFeatures'][number] & {
  onTooltipClick?: () => void,
}> = ({
  icon,
  title,
  description,
  priceEyebrow,
  price,
  priceDescription,
  onTooltipClick,
}) => {
    const { modalActionHandler } = useModalButtonActions();

    return (
      <div className="flex flex-wrap bg-violet-800 rounded-[8px] p-[32px] items-start w-full mb-[24px] md:mb-0 max-w-50 h-50">
        <div className="flex w-full flex-wrap items-start">
          <div className="flex w-[48px] h-[48px] bg-citron-500 justify-center items-center rounded-[8px]">
            {icon}
          </div>
          <div className="flex w-full text-blue-100 font-500 text-h3 mt-[20px] mb-[8px]">
            {title}
          </div>
          <div className="flex w-full text-violet-200 text-p2">
            {description}
          </div>
        </div>
        <div className="flex w-full flex-wrap items-end mt-[32px] md:mt-[48px]">
          {priceEyebrow && (
            <div className="text-violet-200 text-caption2">{priceEyebrow}</div>
          )}
          <div className="flex w-full text-violet-200 text-caption2 items-center">
            <span>
              <span className="text-blue-100 font-500 text-p2">{price}</span> {priceDescription}
            </span>
            {onTooltipClick && (
              <button
                className="flex font-500 text-white text-p2 items-center my-auto hover-arrow-wrapper gap-xs"
                onClick={onTooltipClick}
              >
                <ThemeWrapper theme="theme-dark-violet">
                  <Icon className='mt-[2px] ml-[6px] icon-action-inactive' name="info-circle" size={16} />
                </ThemeWrapper>
              </button>
            )}
          </div>
          <button
            className="flex font-500 text-white text-p2 items-center mt-[18px] hover-arrow-wrapper"
            onClick={() => {
              modalActionHandler("demo");
            }}
          >
            <span>Talk to sales</span>
            <div className="flex ml-[8px] relative w-[16px] h-[16px] bg-[url(https://front.com/webassets/rebrand/arrow-right.png)] hover-arrow" />
          </button>
        </div>
      </div>
    )
  }
